import React, { useState, useEffect } from 'react';
import { object, func } from 'prop-types';
import DireccionForm from '../DireccionForm';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";


const DomicilioModal = (props) => {

  const entityInit = {
      id: 0,
      entidad: "",
      idEntidad: 0,
      idTipoGeoreferencia: 0,
      idPais: 0,
      idProvincia: 0,
      idLocalidad: 0,
      idZonaGeoreferencia: 0,
      codigoPostal: "",
      calle: "",
      entreCalle1: "",
      entreCalle2: "",
      altura: "",
      piso: "",
      dpto: "",
      referencia: "",
      longitud: 0,
      latitud: 0,
      origen: ""
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit
  });

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.data.entity };
    });
  }
  useEffect(mount, [props.data]);

  return (
    <Modal
      size="lg"
      title={`Domicilio: ${state.entity.domicilio}`}
      tipName={TIPS.NAME.MODALS.DOMICILIO_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">

                <div className="mb-3 col-12">
                  <DireccionForm
                    data={{
                      entity: state.entity
                    }}
                    disabled={true}
                  />
                </div>

            </div>
      )}
      footerClassName="f-align"
      footer={(
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
    />
  );
}

DomicilioModal.propTypes = {
  data: object.isRequired,
  onDismiss: func.isRequired,
};

export default DomicilioModal;